/* OUGIST theme — global JS: cart drawer, mobile menu, accordions, hero carousel, search overlay */
(function () {
  'use strict';

  /* one-time capability check: without fetch, cart AJAX stands down — the
     submit handler does not intercept (browser posts natively) and the
     qty/remove + drawer refresh logic below skips silently */
  var hasFetch = typeof window.fetch === 'function';

  var money = function (cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: currency });
  };

  /* ---------------- Cached chrome refs ----------------
     Re-queried on shopify:section:load so header/drawer/search refs
     stay valid after the theme editor replaces a section. */
  var menuBtn, mobileMenu, cartDrawer, cartBackdrop, searchOverlay;
  function refreshRefs() {
    menuBtn = document.querySelector('[data-menu-toggle]');
    mobileMenu = document.querySelector('[data-mobile-menu]');
    cartDrawer = document.querySelector('[data-cart-drawer]');
    cartBackdrop = document.querySelector('[data-cart-backdrop]');
    searchOverlay = document.querySelector('[data-search-overlay]');
  }
  refreshRefs();

  /* ---------------- Accordions ---------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    var item = trigger.closest('.accordion__item');
    if (!item) return;
    if (item.hasAttribute('data-open')) {
      item.removeAttribute('data-open');
      trigger.setAttribute('aria-expanded', 'false');
    } else {
      item.setAttribute('data-open', '');
      trigger.setAttribute('aria-expanded', 'true');
    }
  });

  /* ---------------- Mobile menu ---------------- */
  function closeMenu(returnFocus) {
    if (!mobileMenu) return;
    var wasOpen = mobileMenu.hasAttribute('data-open');
    mobileMenu.removeAttribute('data-open');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    if (returnFocus && wasOpen && menuBtn) menuBtn.focus();
  }

  /* delegated so it survives header section reloads in the editor */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle && mobileMenu) {
      if (mobileMenu.hasAttribute('data-open')) {
        closeMenu();
      } else {
        mobileMenu.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (mobileMenu && mobileMenu.hasAttribute('data-open') && e.target.closest('[data-mobile-menu] a')) {
      closeMenu();
    }
  });

  /* ---------------- Header nav dropdowns ----------------
     Delegated like the rest of the chrome handlers, so it keeps working when
     the editor re-renders the header section (no per-element listeners that
     would go stale or leak). */
  function closeDropdowns(except) {
    document.querySelectorAll('.site-header__dropdown[data-open]').forEach(function (dropdown) {
      if (dropdown === except) return;
      dropdown.removeAttribute('data-open');
      var link = dropdown.querySelector('.site-header__link');
      if (link) link.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.site-header__dropdown > .site-header__link');
    if (trigger) {
      var dropdown = trigger.parentElement;
      /* second click on an open trigger follows the link (unchanged behavior) */
      if (!dropdown.hasAttribute('data-open')) {
        e.preventDefault();
        closeDropdowns(dropdown);
        dropdown.setAttribute('data-open', '');
        trigger.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (!e.target.closest('.site-header__dropdown')) closeDropdowns(null);
  });

  /* CSS :focus-within opens the panel too (keyboard users never hit the
     click path) — keep the trigger's aria-expanded in sync with that. */
  document.addEventListener('focusin', function (e) {
    var dropdown = e.target.closest('.site-header__dropdown');
    if (!dropdown) return;
    var link = dropdown.querySelector('.site-header__link');
    if (link) link.setAttribute('aria-expanded', 'true');
  });
  document.addEventListener('focusout', function (e) {
    var dropdown = e.target.closest('.site-header__dropdown');
    if (!dropdown) return;
    /* focus moved elsewhere inside the same dropdown — still open */
    if (e.relatedTarget && dropdown.contains(e.relatedTarget)) return;
    var link = dropdown.querySelector('.site-header__link');
    if (link) link.setAttribute('aria-expanded', 'false');
  });

  /* ---------------- Cart drawer ---------------- */
  var FREE_SHIPPING_CENTS = 3500;
  var cartTrigger = null;

  function lockScroll(lock) {
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function focusFirst(container) {
    var el = container.querySelector('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]');
    if (el) el.focus();
  }

  /* keep Tab cycling inside an open dialog (cart drawer / search overlay).
     Re-collected on every keydown so dynamically rebuilt content stays right,
     and hidden nodes (e.g. the display:none cart foot) are filtered out. */
  function trapTab(container, e) {
    var focusables = Array.prototype.slice.call(
      container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) {
      return el.getClientRects().length > 0;
    });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    /* focus ended up outside the dialog (e.g. its content was rebuilt) — pull
       it back in instead of letting Tab walk the page behind it */
    if (!container.contains(document.activeElement)) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
      return;
    }
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function onCartKeydown(e) {
    if (e.key !== 'Tab' || !cartDrawer) return;
    trapTab(cartDrawer, e);
  }

  function openCart(trigger) {
    if (!cartDrawer) return;
    cartTrigger = trigger || document.activeElement;
    cartDrawer.setAttribute('data-open', '');
    cartDrawer.setAttribute('aria-modal', 'true');
    cartBackdrop && cartBackdrop.setAttribute('data-open', '');
    lockScroll(true);
    document.addEventListener('keydown', onCartKeydown);
    focusFirst(cartDrawer);
  }
  function closeCart() {
    if (!cartDrawer) return;
    var wasOpen = cartDrawer.hasAttribute('data-open');
    cartDrawer.removeAttribute('data-open');
    cartDrawer.removeAttribute('aria-modal');
    cartBackdrop && cartBackdrop.removeAttribute('data-open');
    lockScroll(false);
    document.removeEventListener('keydown', onCartKeydown);
    if (wasOpen && cartTrigger && document.contains(cartTrigger)) {
      cartTrigger.focus();
    }
    cartTrigger = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener) { e.preventDefault(); openCart(opener); }
    if (e.target.closest('[data-cart-close]')) { closeCart(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeCart();
    closeSearch();
    closeMenu(true);
    closeDropdowns(null);
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-video-play]');
    if (!btn) return;
    var frame = btn.closest('[data-video-frame]');
    if (!frame) return;
    var tpl = frame.querySelector('template[data-video-embed]');
    if (!tpl) return;
    frame.innerHTML = '';
    frame.appendChild(tpl.content.cloneNode(true));
    var media = frame.querySelector('iframe, video');
    if (!media) return;
    media.style.position = 'absolute';
    media.style.inset = '0';
    media.style.width = '100%';
    media.style.height = '100%';
    media.style.border = '0';
    media.setAttribute('tabindex', '-1');
    media.focus();
  });

  /* rebuilding the drawer drops the focused node (focus falls back to body);
     pull it back inside while the drawer is open so Tab can't escape */
  function refocusCart() {
    if (cartDrawer && cartDrawer.hasAttribute('data-open') && !cartDrawer.contains(document.activeElement)) {
      focusFirst(cartDrawer);
    }
  }

  function renderCart(cart) {
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    if (!cartDrawer) return;
    var body = cartDrawer.querySelector('[data-cart-items]');
    var foot = cartDrawer.querySelector('[data-cart-foot]');
    var empty = cartDrawer.querySelector('[data-cart-empty]');
    var titleCount = cartDrawer.querySelector('[data-cart-title-count]');
    if (titleCount) titleCount.textContent = '(' + cart.item_count + ')';

    if (!cart.item_count) {
      if (body) body.innerHTML = '';
      if (foot) foot.style.display = 'none';
      if (empty) empty.style.display = '';
      refocusCart();
      return;
    }
    if (empty) empty.style.display = 'none';
    if (foot) foot.style.display = '';

    if (body) {
      /* build with DOM APIs + textContent so product titles can never inject markup */
      while (body.firstChild) body.removeChild(body.firstChild);
      cart.items.forEach(function (item) {
        var row = document.createElement('div');
        row.className = 'cart-item';
        row.setAttribute('data-line-key', item.key);

        var imgLink = document.createElement('a');
        imgLink.className = 'cart-item__img';
        imgLink.href = item.url;
        /* decorative duplicate of the title link — keep it out of the tab
           order and a11y tree, same as the server-rendered markup */
        imgLink.setAttribute('aria-hidden', 'true');
        imgLink.setAttribute('tabindex', '-1');
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = '';
          img.width = 64;
          img.height = 64;
          imgLink.appendChild(img);
        }

        var info = document.createElement('div');
        info.className = 'cart-item__info';
        var title = document.createElement('a');
        title.className = 'cart-item__title';
        title.href = item.url;
        title.textContent = item.product_title;
        info.appendChild(title);
        if (item.variant_title && item.variant_title !== 'Default Title') {
          var variant = document.createElement('p');
          variant.className = 'cart-item__variant';
          variant.textContent = item.variant_title;
          info.appendChild(variant);
        }
        var price = document.createElement('p');
        price.className = 'cart-item__price';
        price.textContent = money(item.final_price) + ' each';
        info.appendChild(price);
        var qty = document.createElement('div');
        qty.className = 'cart-item__qty';
        var minus = document.createElement('button');
        minus.type = 'button';
        minus.setAttribute('data-cart-qty', '-1');
        minus.setAttribute('aria-label', 'Decrease');
        minus.textContent = '−';
        var qtyVal = document.createElement('span');
        qtyVal.textContent = item.quantity;
        var plus = document.createElement('button');
        plus.type = 'button';
        plus.setAttribute('data-cart-qty', '1');
        plus.setAttribute('aria-label', 'Increase');
        plus.textContent = '+';
        qty.appendChild(minus);
        qty.appendChild(qtyVal);
        qty.appendChild(plus);
        info.appendChild(qty);

        var right = document.createElement('div');
        right.className = 'cart-item__right';
        var total = document.createElement('p');
        total.className = 'cart-item__total';
        total.textContent = money(item.final_line_price);
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.setAttribute('data-cart-remove', '');
        remove.setAttribute('aria-label', 'Remove item');
        remove.textContent = '✕';
        right.appendChild(total);
        right.appendChild(remove);

        row.appendChild(imgLink);
        row.appendChild(info);
        row.appendChild(right);
        body.appendChild(row);
      });
    }

    var subtotalEl = foot.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    var bar = foot.querySelector('[data-shipping-bar]');
    if (bar) bar.style.width = Math.min(100, (cart.total_price / FREE_SHIPPING_CENTS) * 100) + '%';
    refocusCart();
  }

  function refreshCart() {
    if (!hasFetch) return Promise.resolve();
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  /* expose cart helpers for section-level scripts (e.g. FBT multi-add) */
  window.OUGIST = window.OUGIST || {};
  window.OUGIST.refreshCart = refreshCart;
  window.OUGIST.openCart = openCart;

  var cartChangeSeq = 0;
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty]');
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!qtyBtn && !removeBtn) return;
    if (!hasFetch) return;
    var row = e.target.closest('.cart-item');
    if (!row) return;
    var key = row.getAttribute('data-line-key');
    var current = parseInt(row.querySelector('.cart-item__qty span').textContent, 10);
    var qty = removeBtn ? 0 : current + parseInt((qtyBtn || removeBtn).getAttribute('data-cart-qty') || '0', 10);
    /* disable the row buttons until the request settles to prevent double-clicks */
    var rowBtns = row.querySelectorAll('[data-cart-qty], [data-cart-remove]');
    rowBtns.forEach(function (b) { b.disabled = true; });
    /* only the latest request is allowed to render */
    var seq = ++cartChangeSeq;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change.js responded ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        if (seq !== cartChangeSeq) {
          /* a newer request owns the render — release this row's buttons in
             case they are still on the page */
          rowBtns.forEach(function (b) { b.disabled = false; });
          return;
        }
        renderCart(cart);
        /* the /cart page keeps its own server-rendered list, which a drawer
           change can't update — reload it so both stay in sync */
        var path = location.pathname.replace(/\/$/, '');
        if (path === '/cart' || path.slice(-5) === '/cart') location.reload();
      })
      .catch(function () {
        if (seq === cartChangeSeq) {
          rowBtns.forEach(function (b) { b.disabled = false; });
          /* the change may still have applied server-side — re-pull the cart
             to reconcile (a GET, so it can't retrigger this handler) */
          refreshCart().catch(function () {});
        }
      });
  });

  /* ---------------- Add to cart (AJAX forms) ---------------- */
  function findQuickAddVariant(product, selectedOptions) {
    for (var i = 0; i < product.variants.length; i += 1) {
      var variant = product.variants[i];
      if (variant.options.every(function (value, index) { return value === selectedOptions[index]; })) return variant;
    }
    return null;
  }

  var quickAddDialog = document.querySelector('[data-quick-add-dialog]');
  var quickAddOptions = quickAddDialog && quickAddDialog.querySelector('[data-quick-add-options]');
  var quickAddVariant = quickAddDialog && quickAddDialog.querySelector('[data-quick-add-variant]');
  var quickAddSubmit = quickAddDialog && quickAddDialog.querySelector('[data-quick-add-submit]');
  var quickAddPrice = quickAddDialog && quickAddDialog.querySelector('[data-quick-add-price]');
  var quickAddError = quickAddDialog && quickAddDialog.querySelector('[data-quick-add-error]');
  var quickAddProduct = null;
  var quickAddProductUrl = null;
  var quickAddTrigger = null;
  var quickAddProducts = {};

  function setQuickAddError(message) {
    if (!quickAddError) return;
    quickAddError.textContent = message || '';
    quickAddError.hidden = !message;
  }

  function syncQuickAddVariant() {
    if (!quickAddProduct) return;
    var selectedOptions = Array.prototype.map.call(quickAddOptions.querySelectorAll('select'), function (select) { return select.value; });
    var variant = findQuickAddVariant(quickAddProduct, selectedOptions);
    var available = variant && variant.available;
    quickAddVariant.value = variant ? variant.id : '';
    quickAddPrice.textContent = variant ? money(variant.price) : '';
    quickAddSubmit.disabled = !available;
    quickAddSubmit.textContent = available ? 'Add to cart' : 'Sold out';
    setQuickAddError('');
  }

  function renderQuickAddProduct(product) {
    quickAddProduct = product;
    quickAddOptions.textContent = '';
    var initialVariant = product.variants.find(function (variant) { return variant.available; }) || product.variants[0];

    product.options.forEach(function (productOption, optionIndex) {
      var field = document.createElement('label');
      field.className = 'quick-add-dialog__option';
      var label = document.createElement('span');
      label.className = 'label';
      label.textContent = productOption.name;
      var select = document.createElement('select');
      select.className = 'select';
      select.setAttribute('aria-label', productOption.name);
      productOption.values.forEach(function (value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        option.selected = initialVariant && initialVariant.options[optionIndex] === value;
        select.appendChild(option);
      });
      field.appendChild(label);
      field.appendChild(select);
      quickAddOptions.appendChild(field);
    });

    syncQuickAddVariant();
    var firstSelect = quickAddOptions.querySelector('select');
    if (firstSelect) firstSelect.focus();
  }

  function loadQuickAddProduct(productUrl) {
    if (!quickAddProducts[productUrl]) {
      quickAddProducts[productUrl] = fetch(productUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('product.js responded ' + response.status);
          return response.json();
        })
        .catch(function (error) {
          delete quickAddProducts[productUrl];
          throw error;
        });
    }
    return quickAddProducts[productUrl];
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-add]');
    if (!trigger) return;
    var productUrl = trigger.getAttribute('data-product-url');
    if (!quickAddDialog || typeof quickAddDialog.showModal !== 'function' || !hasFetch) return;
    event.preventDefault();
    quickAddTrigger = trigger;
    quickAddProductUrl = productUrl;
    quickAddProduct = null;
    quickAddOptions.textContent = 'Loading options…';
    quickAddSubmit.disabled = true;
    quickAddPrice.textContent = '';
    setQuickAddError('');

    quickAddDialog.querySelector('[data-quick-add-title]').textContent = trigger.getAttribute('data-product-title');
    var image = quickAddDialog.querySelector('[data-quick-add-image]');
    var imageUrl = trigger.getAttribute('data-product-image');
    image.hidden = !imageUrl;
    if (imageUrl) image.src = imageUrl;
    quickAddDialog.showModal();

    loadQuickAddProduct(productUrl).then(function (product) {
      if (quickAddProductUrl !== productUrl || !quickAddDialog.open) return;
      renderQuickAddProduct(product);
    }).catch(function () {
      if (quickAddProductUrl !== productUrl || !quickAddDialog.open) return;
      quickAddOptions.textContent = '';
      setQuickAddError('Sorry, the options could not be loaded. Please try again.');
    });
  });

  if (quickAddDialog) {
    quickAddOptions.addEventListener('change', syncQuickAddVariant);
    quickAddDialog.addEventListener('click', function (event) {
      if (event.target === quickAddDialog || event.target.closest('[data-quick-add-close]')) quickAddDialog.close();
    });
    quickAddDialog.addEventListener('close', function () {
      quickAddProductUrl = null;
      if (quickAddTrigger) quickAddTrigger.focus();
    });
  }

  function showCartFormError(form) {
    var dialogError = form.closest('[data-quick-add-dialog]') && form.querySelector('[data-quick-add-error]');
    if (dialogError) {
      dialogError.textContent = 'Sorry, this item could not be added to your cart. Please try again.';
      dialogError.hidden = false;
      return;
    }
    var old = form.parentNode && form.parentNode.querySelector('.cart-form-error');
    if (old) old.remove();
    var msg = document.createElement('p');
    msg.className = 'cart-form-error';
    msg.setAttribute('role', 'alert');
    msg.style.color = '#B3401F';
    msg.style.marginTop = '0.5rem';
    msg.textContent = 'Sorry, this item could not be added to your cart. Please try again.';
    form.insertAdjacentElement('afterend', msg);
    setTimeout(function () { msg.remove(); }, 3000);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    /* without fetch, do not intercept — let the browser post natively */
    if (!form || !hasFetch) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    var isQuickAdd = quickAddDialog && form.closest('[data-quick-add-dialog]') === quickAddDialog;
    if (isQuickAdd) setQuickAddError('');
    if (submitBtn) submitBtn.disabled = true;
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data })
      .then(function (r) {
        if (!r.ok) throw new Error('add.js responded ' + r.status);
        return r.json();
      })
      .then(function () {
        /* the item is in the cart at this point; a failed re-render must
           not surface as an add-to-cart error */
        return refreshCart().catch(function (err) {
          if (window.console && console.warn) console.warn('cart refresh failed:', err);
        });
      })
      .then(function () {
        if (submitBtn) submitBtn.disabled = false;
        if (isQuickAdd) quickAddDialog.close();
        openCart(isQuickAdd ? quickAddTrigger : submitBtn);
      })
      .catch(function () {
        if (submitBtn) submitBtn.disabled = false;
        showCartFormError(form);
      });
  });

  /* ---------------- Search overlay ---------------- */
  var searchTrigger = null;

  /* panel only holds the input + close button; reuse the drawer trap */
  function onSearchKeydown(e) {
    if (e.key !== 'Tab' || !searchOverlay) return;
    trapTab(searchOverlay, e);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    var wasOpen = searchOverlay.hasAttribute('data-open');
    searchOverlay.removeAttribute('data-open');
    searchOverlay.removeAttribute('aria-modal');
    lockScroll(false);
    document.removeEventListener('keydown', onSearchKeydown);
    /* give focus back to the trigger when it was left inside the overlay */
    if (wasOpen && searchOverlay.contains(document.activeElement) && searchTrigger && document.contains(searchTrigger)) {
      searchTrigger.focus();
    }
    if (wasOpen) searchTrigger = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-search-open]');
    if (opener && searchOverlay) {
      searchTrigger = opener;
      searchOverlay.setAttribute('data-open', '');
      searchOverlay.setAttribute('aria-modal', 'true');
      lockScroll(true);
      document.addEventListener('keydown', onSearchKeydown);
      var input = searchOverlay.querySelector('input[type="search"]');
      input && input.focus();
    }
    if (e.target.closest('[data-search-close]')) {
      closeSearch();
    }
  });

  /* ---------------- Hero carousel ---------------- */
  var carousels = [];
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* toggleAttribute is missing on older browsers — tiny fallback */
  var toggleAttr = function (el, name, force) {
    if (el.toggleAttribute) { el.toggleAttribute(name, force); return; }
    var on = force !== undefined ? !!force : !el.hasAttribute(name);
    if (on) { el.setAttribute(name, ''); } else { el.removeAttribute(name); }
  };

  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var delay = parseInt(root.getAttribute('data-autoplay') || '0', 10);
    var index = 0;
    var paused = false;
    var timer = null;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      slides.forEach(function (s, j) { toggleAttr(s, 'data-active', j === index); });
      dots.forEach(function (d, j) { toggleAttr(d, 'data-active', j === index); });
    }
    prev && prev.addEventListener('click', function () { go(index - 1); });
    next && next.addEventListener('click', function () { go(index + 1); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });

    /* touch swipe */
    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; paused = true; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      startX = null;
      paused = false;
    }, { passive: true });
    root.addEventListener('touchcancel', function () { startX = null; paused = false; }, { passive: true });
    root.addEventListener('pointerenter', function () { paused = true; });
    root.addEventListener('pointerleave', function () { paused = false; });

    function stopAutoplay() {
      if (timer !== null) {
        clearInterval(timer);
        timer = null;
      }
    }
    function startAutoplay() {
      stopAutoplay();
      if (delay > 0 && !reducedMotion) {
        timer = setInterval(function () { if (!paused) go(index + 1); }, delay);
      }
    }
    function onVisibilityChange() {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    }
    document.addEventListener('visibilitychange', onVisibilityChange);

    go(0);
    startAutoplay();

    carousels.push({
      root: root,
      destroy: function () {
        stopAutoplay();
        document.removeEventListener('visibilitychange', onVisibilityChange);
      },
    });
  }

  function initCarousels(scope) {
    scope.querySelectorAll('[data-carousel]').forEach(initCarousel);
  }
  initCarousels(document);

  /* Theme editor support: re-cache chrome refs and re-init carousels when a
     section is re-rendered, and clear timers of sections being removed. */
  document.addEventListener('shopify:section:load', function (e) {
    refreshRefs();
    carousels = carousels.filter(function (c) {
      if (!document.contains(c.root)) { c.destroy(); return false; }
      return true;
    });
    if (e.target && e.target.querySelectorAll) initCarousels(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    carousels = carousels.filter(function (c) {
      if (e.target && e.target.contains && e.target.contains(c.root)) { c.destroy(); return false; }
      return true;
    });
  });

  /* ---------------- Scenario tabs ---------------- */
  function activateScenarioTab(tab, moveFocus) {
    var scope = tab.closest('[data-scenario]');
    if (!scope) return;
    var target = tab.getAttribute('data-scenario-tab');
    scope.querySelectorAll('[data-scenario-tab]').forEach(function (item) {
      var selected = item === tab;
      toggleAttr(item, 'data-active', selected);
      item.setAttribute('aria-selected', selected ? 'true' : 'false');
      item.setAttribute('tabindex', selected ? '0' : '-1');
    });
    scope.querySelectorAll('[data-scenario-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-scenario-panel') !== target;
    });
    if (moveFocus) tab.focus();
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-scenario-tab]');
    if (!tab) return;
    activateScenarioTab(tab, false);
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest('[data-scenario-tab]');
    if (!tab || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(e.key)) return;
    var tabs = Array.prototype.slice.call(tab.closest('[role="tablist"]').querySelectorAll('[data-scenario-tab]'));
    var index = tabs.indexOf(tab);
    if (index < 0) return;
    e.preventDefault();
    if (e.key === 'Home') index = 0;
    else if (e.key === 'End') index = tabs.length - 1;
    else index = (index + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    activateScenarioTab(tabs[index], true);
  });
})();
